import type { CourseId } from "../learn/engine/lessonRegistry";

export function lessonPath(
  course: CourseId,
  unit: number,
  lesson: number,
): string {
  const base = course === "apcsp" ? "/csp" : "";
  return `${base}/unit${unit}/lesson${lesson}`;
}

export interface LessonRouteInfo {
  course: CourseId;
  unit: number;
  lesson: number;
}

export function parseLessonPath(pathname: string): LessonRouteInfo | null {
  const apMatch = pathname.match(/^\/csp\/unit(\d+)\/lesson(\d+)$/);
  if (apMatch) {
    return {
      course: "apcsp",
      unit: Number(apMatch[1]),
      lesson: Number(apMatch[2]),
    };
  }
  const match = pathname.match(/^\/unit(\d+)\/lesson(\d+)$/);
  if (!match) return null;
  return {
    course: "classic",
    unit: Number(match[1]),
    lesson: Number(match[2]),
  };
}

export function isHomePath(pathname: string): boolean {
  return pathname === "/" || pathname === "";
}

export function coursePath(course: CourseId): string {
  return course === "apcsp" ? "/csp" : "/classic";
}
